import { makeStyles } from 'tss-react/mui';

export type ProgressBarProps = {
  progressPercentage: number;
};

export const ProgressBar: React.VFC<ProgressBarProps> = ({ progressPercentage = 0 }) => {
  const { classes } = useProgressBarStyles();

  return (
    <div className={classes.root}>
      <div
        className={classes.progress}
        style={{ width: `${progressPercentage}%` }}
        data-testid={`progress-bar-${progressPercentage}-percents`}
      />
    </div>
  );
};

const useProgressBarStyles = makeStyles({ name: 'ProgressBar' })(theme => ({
  root: {
    height: '10px',
    backgroundColor: 'rgba(228, 228, 228, 1)',
    width: '100%',
  },
  progress: {
    background: theme.palette.secondary.light,
    height: 'inherit',
    transition: 'width 0.5s',
  }
}));
